import { Formik, Form, Field, FieldArray, useFormikContext, useField, ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import * as Yup from 'yup'
import swal from '@sweetalert/with-react';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';

function EmsStage2AuditReport() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
            label: "",
            value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
            label: "",
            value: ""
    }])
    const [technicalExpertList,setTechnicalExpertList] = useState([{
            label:"",
            value:""
    }])
    const options = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    const yesNo = [
        { key: 'Select', value: '-' },
        { key: 'C', value: 'C' },
        { key: 'NC', value: 'NC' },
        { key: 'O', value: 'O' },
    ]
    const [initialValues, setInitialValues] = useState({
        id: "",
        orgCode: 0,
        address:"",
        siteofaddress:"",
        total:"",
        mobile:"",
        email:"",
        contactPersonName:"",
        scope:"",
        stageOneAudit:"",
        auditdate1:new Date(),
        stageTwoAudit:"",
        auditdate2:new Date(),
        dateofaudit:new Date(),
        dateofauditto:new Date(),
        auditobjective:"",
        briefaboutorg:"",
        areqquatedmandays:"",
        istherechangeemployee:"",
        istherechangescope:"",
        isthereanyinforevent:"",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        technicalexpert: "",
        auditcheckliststatustwo1:"C",
        remarkauditchecklisttwo1:"",
        auditcheckliststatustwo2:"C",
        remarkauditchecklisttwo2:"",
        auditcheckliststatustwo3:"C",
        remarkauditchecklisttwo3:"",
        auditcheckliststatustwo4:"C",
        remarkauditchecklisttwo4:"",
        auditcheckliststatustwo5:"C",
        remarkauditchecklisttwo5:"",
        auditcheckliststatustwo6:"C",
        remarkauditchecklisttwo6:"",
        auditcheckliststatustwo7:"C",
        remarkauditchecklisttwo7:"",
        auditcheckliststatustwo8:"C",
        remarkauditchecklisttwo8:"",
        auditcheckliststatustwo9:"C",
        remarkauditchecklisttwo9:"",
        auditcheckliststatustwo10:"C",
        remarkauditchecklisttwo10:"",
        auditcheckliststatustwo11:"C",
        remarkauditchecklisttwo11:"",
        auditcheckliststatustwo12:"C",
        remarkauditchecklisttwo12:"",
        auditcheckliststatustwo13:"C",
        remarkauditchecklisttwo13:"",
        auditcheckliststatustwo14:"C",
        remarkauditchecklisttwo14:"",
        auditcheckliststatustwo15:"C",
        remarkauditchecklisttwo15:"",
        auditcheckliststatustwo16:"C",
        remarkauditchecklisttwo16:"",
        auditcheckliststatustwo17:"C",
        remarkauditchecklisttwo17:"",
        auditcheckliststatustwo18:"C",
        remarkauditchecklisttwo18:"",
        auditcheckliststatustwo19:"C",
        remarkauditchecklisttwo19:"",
        auditcheckliststatustwo20:"C",
        remarkauditchecklisttwo20:"",
        auditcheckliststatustwo21:"C",
        remarkauditchecklisttwo21:"",
        auditcheckliststatustwo22:"C",
        remarkauditchecklisttwo22:"",
        auditcheckliststatustwo23:"C",
        remarkauditchecklisttwo23:"",
        auditcheckliststatustwo24:"C",
        remarkauditchecklisttwo24:"",
        auditcheckliststatustwo25:"C",
        remarkauditchecklisttwo25:"",
        auditcheckliststatustwo26:"C",
        remarkauditchecklisttwo26:"",

       

    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values", values)
        mutation.mutate(values)
    }
    const validationSchema = Yup.object({
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stage2auditreport14001', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Stage 2 Audit Report Data Added')
                //history.push("/" + localStorage.getItem("role") + '/viewauditteamproposal/' + data.data.response.orgCode);
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
                tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.auditorOne = data.data.response.auditorOne || "";
                tempInitialValues.auditorTwo = data.data.response.auditorTwo || "";
                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";

                tempInitialValues.auditcheckliststatustwo1 = data.data.response.auditcheckliststatustwo1 || "C";
                tempInitialValues.remarkauditchecklisttwo1 = data.data.response.remarkauditchecklisttwo1 || "";
                tempInitialValues.auditcheckliststatustwo2 = data.data.response.auditcheckliststatustwo2 || "C";
                tempInitialValues.remarkauditchecklisttwo2 = data.data.response.remarkauditchecklisttwo2 || "";
                tempInitialValues.auditcheckliststatustwo3 = data.data.response.auditcheckliststatustwo3 || "C";
                tempInitialValues.remarkauditchecklisttwo3 = data.data.response.remarkauditchecklisttwo3 || "";
                tempInitialValues.auditcheckliststatustwo4 = data.data.response.auditcheckliststatustwo4 || "C";
                tempInitialValues.remarkauditchecklisttwo4 = data.data.response.remarkauditchecklisttwo4 || "";
                tempInitialValues.auditcheckliststatustwo5 = data.data.response.auditcheckliststatustwo5 || "C";
                tempInitialValues.remarkauditchecklisttwo5 = data.data.response.remarkauditchecklisttwo5 || "";
                tempInitialValues.auditcheckliststatustwo6 = data.data.response.auditcheckliststatustwo6 || "C";
                tempInitialValues.remarkauditchecklisttwo6 = data.data.response.remarkauditchecklisttwo6 || "";
                tempInitialValues.auditcheckliststatustwo7 = data.data.response.auditcheckliststatustwo7 || "C";
                tempInitialValues.remarkauditchecklisttwo7 = data.data.response.remarkauditchecklisttwo7 || "";
                tempInitialValues.auditcheckliststatustwo8 = data.data.response.auditcheckliststatustwo8 || "C";
                tempInitialValues.remarkauditchecklisttwo8 = data.data.response.remarkauditchecklisttwo8 || "";
                tempInitialValues.auditcheckliststatustwo9 = data.data.response.auditcheckliststatustwo9 || "C";
                tempInitialValues.remarkauditchecklisttwo9 = data.data.response.remarkauditchecklisttwo9 || "";
                tempInitialValues.auditcheckliststatustwo10 = data.data.response.auditcheckliststatustwo10 || "C";
                tempInitialValues.remarkauditchecklisttwo10 = data.data.response.remarkauditchecklisttwo10 || "";
                tempInitialValues.auditcheckliststatustwo11 = data.data.response.auditcheckliststatustwo11 || "C";
                tempInitialValues.remarkauditchecklisttwo11 = data.data.response.remarkauditchecklisttwo11 || "";
                tempInitialValues.auditcheckliststatustwo12 = data.data.response.auditcheckliststatustwo12 || "C";
                tempInitialValues.remarkauditchecklisttwo12 = data.data.response.remarkauditchecklisttwo12 || "";
                tempInitialValues.auditcheckliststatustwo13 = data.data.response.auditcheckliststatustwo13 || "C";
                tempInitialValues.remarkauditchecklisttwo13 = data.data.response.remarkauditchecklisttwo13 || "";
                tempInitialValues.auditcheckliststatustwo14 = data.data.response.auditcheckliststatustwo14 || "C";
                tempInitialValues.remarkauditchecklisttwo14 = data.data.response.remarkauditchecklisttwo14 || "";
                tempInitialValues.auditcheckliststatustwo15 = data.data.response.auditcheckliststatustwo15 || "C";
                tempInitialValues.remarkauditchecklisttwo15 = data.data.response.remarkauditchecklisttwo15 || "";
                tempInitialValues.auditcheckliststatustwo16 = data.data.response.auditcheckliststatustwo16 || "C";
                tempInitialValues.remarkauditchecklisttwo16 = data.data.response.remarkauditchecklisttwo16 || "";
                tempInitialValues.auditcheckliststatustwo17 = data.data.response.auditcheckliststatustwo17 || "C";
                tempInitialValues.remarkauditchecklisttwo17 = data.data.response.remarkauditchecklisttwo17 || "";
                tempInitialValues.auditcheckliststatustwo18 = data.data.response.auditcheckliststatustwo18 || "C";
                tempInitialValues.remarkauditchecklisttwo18 = data.data.response.remarkauditchecklisttwo18 || "";
                tempInitialValues.auditcheckliststatustwo19 = data.data.response.auditcheckliststatustwo19 || "C";
                tempInitialValues.remarkauditchecklisttwo19 = data.data.response.remarkauditchecklisttwo19 || "";
                tempInitialValues.auditcheckliststatustwo20 = data.data.response.auditcheckliststatustwo20 || "C";
                tempInitialValues.remarkauditchecklisttwo20 = data.data.response.remarkauditchecklisttwo20 || "";
                tempInitialValues.auditcheckliststatustwo21 = data.data.response.auditcheckliststatustwo21 || "C";
                tempInitialValues.remarkauditchecklisttwo21 = data.data.response.remarkauditchecklisttwo21 || "";
                tempInitialValues.auditcheckliststatustwo22 = data.data.response.auditcheckliststatustwo22 || "C";
                tempInitialValues.remarkauditchecklisttwo22 = data.data.response.remarkauditchecklisttwo22 || "";
                tempInitialValues.auditcheckliststatustwo23 = data.data.response.auditcheckliststatustwo23 || "C";
                tempInitialValues.remarkauditchecklisttwo23 = data.data.response.remarkauditchecklisttwo23 || "";
                tempInitialValues.auditcheckliststatustwo24 = data.data.response.auditcheckliststatustwo24 || "C";
                tempInitialValues.remarkauditchecklisttwo24 = data.data.response.remarkauditchecklisttwo24 || "";
                tempInitialValues.auditcheckliststatustwo25 = data.data.response.auditcheckliststatustwo25 || "C";
                tempInitialValues.remarkauditchecklisttwo25 = data.data.response.remarkauditchecklisttwo25 || "";
                tempInitialValues.auditcheckliststatustwo26 = data.data.response.auditcheckliststatustwo26 || "C";
                tempInitialValues.remarkauditchecklisttwo26 = data.data.response.remarkauditchecklisttwo26 || "";

                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }

               

            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of ast Auditor", data.data.response)
                setassitAuditorList(data.data.response)
                
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert",data)
            
            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert",data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { orgcode } = useParams()
   
    const { data: orgList, isLoading: companyListLoading } = useQuery(
        'emsstage1auditreport',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesemsstage1audreport14001/' + localStorage.getItem("userCode"), {}))
    
    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
                var tempData = Rfqdata.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                tempData.auditdate1 = Date.parse(tempData.auditdate1);
                tempData.auditdate2 = Date.parse(tempData.auditdate2);
                setInitialValues(tempData)
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nacecode && tempData.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                }

            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    if (companyListLoading) return <h1>Loading</h1>
   
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
           // validationSchema={validationSchema}
           onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">

                                                    <div className="formOuterDiv">

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='selectNACECode' type='text' options={orgList.data.response} label='Client Name' name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Site Address' name='siteofaddress' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                                                            
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Mobile' name='mobile' disabled={true} />
                                                            <FormikControl control='input' type="text" label='Email' name='email' disabled={true} />
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Contact Person Name *' name='contactPersonName' />
                                                        {/* <FormikControl control='input' type="text" label='Position *' name='position' /> */}
                                                    </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Scope of Application' name='scope' disabled={true} />
                                                        </div>
                                                        
                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`,parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode'  label='Technical Expert'  options={technicalExpertList}   name='technicalexpert'
                                                                     onChange={(e) => {
                                                                            
                                                                        formik.setFieldValue(`technicalexpert`, e.value)
                                                                        formik.setFieldValue(`technicalExpertName`, e.label)
                                                                    }}
                                                                       
                                                                    values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />
                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Mandays</h5>
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 1 Mandays *' name='stageOneAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label=' Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy"  />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 2 Mandays *' name='stageTwoAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label='  Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit From' name='dateofaudit' disabled={true}/>
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit To' name='dateofauditto' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Audit Objective' name='auditobjective' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg' label='Brief about the organization *' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Verification of the Audit Duration</h5>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Are quoted man-days adequate?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='areqquatedmandays' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in employee detail after application?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangeemployee' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in Scope?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangescope' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any information or Event accrued after the application date which may affect the Man-days?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='isthereanyinforevent' options={options} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit CheckList</h5>
                                                        </div>
                                                        <div className="formRowDiv">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead className="table-primary">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th scope="col" className="text-center" width="50%">Clause Number</th>
                                                                                    <th scope="col" className="text-center">Status(C/No/O)</th>
                                                                                    <th scope="col" className="text-center">Document Verification detail with statement of Conformity </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-center">1</td>
                                                                                    <td className="fontcontractviewtable">4.1 Understanding the organization and its context (Determination of external and Internal Issues)</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo1' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo1' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">2</td>
                                                                                    <td className="fontcontractviewtable">4.2 Understanding the needs and expectations of interested parties (Determination, Monitor & Review of the Interested Parties)</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo2' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo2' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">3</td>
                                                                                    <td className="fontcontractviewtable">4.3 Determine and maintained Documented Information the scope of the Environmental management system (Boundaries and Type of Product and Services and any requirement not applicable )
                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo3' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo3' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">4</td>
                                                                                    <td className="fontcontractviewtable">4.4 Environmental management system and its processes (Established, Implement and maintained, process and Interaction of  Process)
                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo4' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo4' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">5</td>
                                                                                    <td className="fontcontractviewtable">5.1 Leadership & Commitment (Statement of ensurity) </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo5' style={{ textAlign: "center" }} /></td>

                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo5' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">6</td>
                                                                                    <td className="fontcontractviewtable">5.2 Environmental policy (Documented Information, Establish, Implement, Maintain, communicated and understood)
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo6' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo6' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">7</td>
                                                                                    <td className="fontcontractviewtable">5.3 Organizational roles, responsibilities and authorities
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo7' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo7' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">8</td>
                                                                                    <td className="fontcontractviewtable">6.1.1 Actions to address risks and opportunities (Risk Assessment has done with prevention of undesirable effects)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo8' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo8' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">9</td>
                                                                                    <td className="fontcontractviewtable">6.1.2  Determination and maintained documented information of Environmental Aspect, associated impacts Criteria Used and significant aspects and, of the activity and Environmental Impacts
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo9' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo9' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">10</td>
                                                                                    <td className="fontcontractviewtable">6.1.3 Determination of the Compliances Obligation and maintained documented information  how to comply.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo10' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo10' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">11</td>
                                                                                    <td className="fontcontractviewtable">6.1.4 Planning action for Environmental aspect, Compliance Obligation and Risk and Opportunities.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo11' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo11' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">12</td>
                                                                                    <td className="fontcontractviewtable">6.2 Environmental objectives and planning to achieve them (Documented, Measurable, Monitored  and  communicated) 

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo12' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo12' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">13</td>
                                                                                    <td className="fontcontractviewtable">7.1 Resources (Resource needed for Continual Improvement ) 

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo13' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo13' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">14</td>
                                                                                    <td className="fontcontractviewtable">7.2 Competence(Employee records & Competence skill matrix)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo14' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo14' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">15</td>
                                                                                    <td className="fontcontractviewtable">7.3 Awareness(Environmental Policy, Objectives & Effectiveness of  EMS)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo15' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo15' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">16</td>
                                                                                    <td className="fontcontractviewtable">7.4 Communication (what, who, when, whom, how with retained documented information)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo16' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo16' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">17</td>
                                                                                    <td className="fontcontractviewtable">7.5 Documented information (External Origin, Creation, Updation, Distribution, Preservation, version control, Retention and disposition)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo17' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo17' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">18</td>
                                                                                    <td className="fontcontractviewtable">8.1 Operational planning and control 
(Plan, Implement and control of process, documented information for process carried our as planned and Conformity of product or services )


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo18' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo18' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">19</td>
                                                                                    <td className="fontcontractviewtable">8.2 Emergency Prepared and Responses 
(Mitigation of Adverse Environmental Impact, Respond to Emergency situation, Periodically review and Training of the Emergency )


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo19' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo19' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">20</td>
                                                                                    <td className="fontcontractviewtable">9.1.1 Monitoring, Measurement analysis and evaluation


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo20' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo20' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">21</td>
                                                                                    <td className="fontcontractviewtable">9.1.2 Evaluation Of Compliances Documented (Frequency and Action on Evaluation)


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo21' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo21' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">22</td>
                                                                                    <td className="fontcontractviewtable">9.2 Internal Audit
( Frequency and Documented Information for Implementation of Audit Program and the audit result)



                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo22' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo22' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">23</td>
                                                                                    <td className="fontcontractviewtable">9.3 Management Review 
(Frequency, Input, Output, Documented Information for MRM Results)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo23' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo23' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">24</td>
                                                                                    <td className="fontcontractviewtable">910.1 Improvement – General


                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo24' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo24' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">25</td>
                                                                                    <td className="fontcontractviewtable">10.2 Nonconformity and corrective action
(Documented Information for nature of NC and result of action taken)

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo25' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo25' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">26</td>
                                                                                    <td className="fontcontractviewtable">10.3 Continual improvement
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatustwo26' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklisttwo26' /> </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                    </div>



                                                        
                                                        <div >

                                                            
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                </Form>
            }
        </Formik>
    )
}

export default EmsStage2AuditReport